import { useSelector } from 'react-redux';
import { Container, FormWrap, OrderWrap } from './OrderDetails.parts';
import { DeliveryAddressForm } from '../../components/DeliveryAddressForm';
import { OrderSummary } from '../../components/OrderSummary';
import { Title } from '../../components/Title';
import { selectorStep } from '../../store/view/view.selectors';
import { PaymentForm } from '../../components/PaymentForm';
import { useGetWindowSize } from '../../hooks/useGetWindowSize';
import { breakpoints } from '../../feachers/theme/tokens/breakpoints';

export const OrderDetails = () => {
  const activeStep = useSelector(selectorStep);
  const { innerWidth } = useGetWindowSize();
  const showOrderSummary = innerWidth > breakpoints.screenMd || activeStep === 4;

  return (
    <Container showOrderSummary={showOrderSummary}>
      <FormWrap>
        {activeStep === 3 && (
          <>
            <Title>DELIVERY DETAILS</Title>
            <DeliveryAddressForm />
          </>
        )}
        {activeStep === 4 && (
          <>
            <Title>PAYMENT DETAILS</Title>
            <PaymentForm />
          </>
        )}
      </FormWrap>
      {showOrderSummary && (
        <OrderWrap>
          <OrderSummary />
        </OrderWrap>
      )}
    </Container>
  );
};
